import { makeStyles } from "@material-ui/core";
import React from "react";

import { BOT_NAME } from "../const";

const useStyles = makeStyles(() => ({
  link: {
    fontFamily: "monospace",
    textDecoration: "none",
  },
}));

export default function BotLink(): React.ReactElement {
  const classes = useStyles();

  return (
    <a className={classes.link} href={`https://t.me/${BOT_NAME}`}>
      @{BOT_NAME}
    </a>
  );
}
